import InvoiceLayoutService from "@/store/services/invoice.layout.service.js"

export default {
  namespaced: true,
  state: {
    defaultFonts: [],
    currentLayouts: [],
    companyLayouts: [],
    defautLayoutValues: []
  },
  getters: {
    getDefaultFonts: state => state.defaultFonts,
    getCurrentLayouts: state => state.currentLayouts,
    getDefaultLayouts: state => state.defautLayoutValues,
    getDefaultLayoutValuesById: state => template_id => state.defautLayoutValues.find(item => item.template === template_id),
    getDefaultLayoutById: state => template_id => state.defautLayoutValues.find(item => item.template === template_id),
    getCompanyLayouts: state => state.companyLayouts,
    getCurrentLayout: state => state.companyLayouts.find(item => item.status === 'current'),
  },
  mutations: {
    SET_COMPANY_LAYOUTS (state, layouts) {
      state.companyLayouts = layouts
    },
    SET_CURRENT_LAYOUTS (state, layouts) {
      state.currentLayouts = layouts
    },
    SET_LAYOUT_FONTS (state, fonts) {
      state.defaultFonts = fonts
    },
    SET_DEFAULT_LAYOUT_VALUES (state, layout_values) {
      state.defautLayoutValues = layout_values
    },
    UPDATE_CURRENT_LAYOUT (state, new_current) {
      const previous_current = state.companyLayouts.find(item => item.status === 'current')
      if (previous_current.template !== new_current.template) {
        previous_current.status = 'old'
      } else {
        previous_current.status = 'latest'
      }
      state.companyLayouts.push(new_current)
    }
  },
  actions: {
    saveLayout ( { commit, dispatch }, data) {
      return InvoiceLayoutService.create(data).then((response) => {
        console.log('saveLayout response ->', response.data)
        dispatch('loadCurrentLayouts')
        dispatch('brands/loadCompanyBrands')
      })
    },
    updateLayout({ commit }, data) {
      return InvoiceLayoutService.update(data.id, data).then((response) => {
        console.log('saveLayout response ->', response.data)
        commit('UPDATE_CURRENT_LAYOUT', response.data)
      })
    },
    loadCompanyLayouts ({ commit, rootGetters }) {
      // TODO switch to v3
      return InvoiceLayoutService.listV2({ company: rootGetters['main/getCurrentCompany'].id }).then((response) => {
        commit('SET_COMPANY_LAYOUTS', response.data)
      })
    },
    loadCurrentLayouts ({ commit, rootGetters }) {
      return InvoiceLayoutService.get_current_layouts({ company: rootGetters['main/getCurrentCompany'].id }).then((response) => {
        // parsing object into array (why is this an object?)
        const outputArray = Object.keys(response.data).map(key => response.data[key])
        commit('SET_CURRENT_LAYOUTS', outputArray)
      })
    },
    loadDefaultLayoutValues ({ commit }) {
      return InvoiceLayoutService.get_default_layout_values().then((response) => {
        // parsing object into array (why is this an object?)
        const outputArray = Object.keys(response.data).map(key => response.data[key])
        commit('SET_DEFAULT_LAYOUT_VALUES', outputArray)
      })
    },
    loadLayoutFonts ({ commit }) {
      return InvoiceLayoutService.get_layout_fonts().then((response) => {
        commit('SET_LAYOUT_FONTS', response.data)
      })
    },
    loadLayoutData ({ dispatch }) {
      return Promise.all([
        dispatch('loadCompanyLayouts'),
        dispatch('loadCurrentLayouts'),
        dispatch('loadDefaultLayoutValues'),
        dispatch('loadLayoutFonts')
      ])
    },
  }
};
